import React, { useState, useEffect } from 'react';

import './view-toggler.scss';

export default function ViewToggler(props) {
    const [direction, setDirection] = useState(() => {
        if (typeof props.value !== 'string') {
            return false;
        }
        return props.value === 'right';
    });

    useEffect(() => {
        if (typeof props.onChange === 'function') {
            props.onChange(direction ? 'right' : 'left');
        }
    }, [direction]);

    function toggle() {
        setDirection(prev => !prev);
    }

    const classes = ['view-toggle-container', direction ? 'right' : 'left', props.size === 'sm' ? 'small' : '', props.size === 'lg' ? 'large' : ''].join(' ');

    return (
        <div className={classes}>
            {typeof props.leftTitle === "string" && <p className="left-title">{props.leftTitle}</p>}
            <div className="view-toggler" onClick={toggle}>
                <div />
            </div>
            {typeof props.rightTitle === "string" && <p className="right-title">{props.rightTitle}</p>}
        </div>
    );
}
